import * as THREE from 'three';
import Game from '../Game/Game';
import gsap from 'gsap';
import Environment from './Environment';
import Time from '../Utils/Time';
import GuitarAudio from '../Game/Audio';

export default class Animations {
    constructor(resource) {
        this.resource  = resource;
        this.model = this.resource.scene;
        this.time = new Time();
        this.animationsFinished = 0;
        this.musicDelay = 2600;
        this.totalAnimationsQuantity = 14;
        this.animationQuaintityOnRestart = 22;
        this.gameTryesQuantity = 0;
        this.isCameraWentInside = false;
        this.environment = new Environment();
        this.environment.updateMaterials();
    }

    addMusic() {
        this.music = new GuitarAudio(this.musicDelay);
        this.music.startMusic();
    }

    setInitialAnimations() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model);
        this.animation.actions = {}
        this.animation.numbersAndLinesAnimations = [];
        this.animation.failureAnimations = [];
        this.animation.raccoonExplosion = [];

        this.animation.actions.carRestart = this.animation.mixer.clipAction(this.resource.animations[1]);
        this.animation.actions.carFailure = this.animation.mixer.clipAction(this.resource.animations[0]);
        this.animation.actions.carSuccess = this.animation.mixer.clipAction(this.resource.animations[2]);
        this.animation.actions.IntroEnvironmentLoop = this.animation.mixer.clipAction(this.resource.animations[3]);
        this.animation.actions.IntroToGameEnvironmentTransition = this.animation.mixer.clipAction(this.resource.animations[4]);
        this.animation.actions.CameraIntroLoop = this.animation.mixer.clipAction(this.resource.animations[6]);
        this.animation.actions.CameraTransitionToTunnel = this.animation.mixer.clipAction(this.resource.animations[8]);
        this.animation.actions.CameraSuccess = this.animation.mixer.clipAction(this.resource.animations[7]);
        this.animation.actions.TunnelAnimation = this.animation.mixer.clipAction(this.resource.animations[24]);

        this.animation.actions.DriverAnimation = this.animation.mixer.clipAction(this.resource.animations[9]);
        this.animation.actions.RaccoonRestart = this.animation.mixer.clipAction(this.resource.animations[19]);
        this.animation.actions.RaccoonSuccess = this.animation.mixer.clipAction(this.resource.animations[18]);

        this.animation.actions.currentCamera = this.animation.actions.CameraIntroLoop;
        this.animation.actions.currentCarAnimation = this.animation.actions.carRestart;
        this.animation.actions.currentRaccoonAnimation = this.animation.actions.RaccoonRestart;
        this.animation.actions.currentEnvironmentAnimation = this.animation.actions.IntroEnvironmentLoop;
        this.animation.actions.currentTunnelAnimation = this.animation.actions.TunnelAnimation;

        this.animation.actions.CameraIntroLoop.play();
        this.animation.actions.currentEnvironmentAnimation.play();
        this.animation.actions.carRestart.play();
        this.animation.actions.DriverAnimation.play();

        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[10]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[11]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[12]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[13]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[14]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[15]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[16]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[20]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[21]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[22]));
        this.animation.numbersAndLinesAnimations.push(this.animation.mixer.clipAction(this.resource.animations[23]));

        this.animation.cameraFailureAnimation = this.animation.mixer.clipAction(this.resource.animations[5]);
        this.animation.raccoonFailure = this.animation.mixer.clipAction(this.resource.animations[17]);

        for (let i = 25; i < this.resource.animations.length; i++) {
            this.animation.raccoonExplosion.push(this.animation.mixer.clipAction(this.resource.animations[i]));
        }
    }

    animationListener() {
        this.animation.mixer.addEventListener('finished', () => {
            this.animationsFinished++;

            if (this.animationsFinished === (8 * this.gameTryesQuantity)){
                this.environment.directionalLight.color.setHex( 0x7BD7FF );
                this.lowSaloonLight();
            }

            if (this.animationsFinished === (this.totalAnimationsQuantity * this.gameTryesQuantity)){
                if(this.game.handleWin()){
                    this.runSuccessScene();
                } else {
                    this.runFailureScene();
                }
            }
        });
    }

    goInsideTheCar() {
        if(this.isCameraWentInside) return;

        this.animationsFinished = 0;
        this.game = new Game();
        this.isGameWinned = false;
        this.gameTryesQuantity++;

        this.addMusic();
        this.playAnimationsWithCrossFade(this.animation.actions.RaccoonRestart, 'currentRaccoonAnimation', 1);
        this.playAnimationsWithCrossFade(this.animation.actions.carRestart, 'currentCarAnimation',0);
        this.playAnimationArrayOnce(this.animation.numbersAndLinesAnimations);
        this.animationListener();
        this.handleAnimationsWhenCameraGoesInside();
    }

    handleAnimationsWhenCameraGoesInside() {
        this.playAnimationsWithCrossFade(this.animation.actions.CameraTransitionToTunnel, 'currentCamera', 0.3);
        this.playAnimationsWithCrossFade(this.animation.actions.IntroToGameEnvironmentTransition, 'currentEnvironmentAnimation', 5);
        this.playAnimationsWithCrossFade(this.animation.actions.TunnelAnimation, 'currentTunnelAnimation', 1);

        // gsap.fromTo(this.environment.saloonLight, {intensity: 0}, {intensity: 25, duration: 4, delay: 10});
        // gsap.fromTo(this.environment.moonLight, {intensity: 10}, {intensity: 0, duration: 1, delay: 9});
        gsap.fromTo(this.environment.rightSaloonLight, {intensity: 0.1}, {intensity: 1.5, duration: 1.1, delay: 12});
        gsap.fromTo(this.environment.leftSaloonLight, {intensity: 0.1}, {intensity: 1.5, duration: 1.1, delay: 12});
        setTimeout(() => {
            this.environment.directionalLight.color.setHex( 0xFFC071 );
        }, 15000);
    }

    lowSaloonLight() {
        gsap.fromTo(this.environment.rightSaloonLight, { intensity: 1.5 }, { intensity: 0, duration: 1.1 });
        gsap.fromTo(this.environment.leftSaloonLight, { intensity: 1.5 }, { intensity: 0, duration: 1.1 });
    }

    runFailureScene() {
        this.playAnimationsWithCrossFade(this.animation.cameraFailureAnimation, 'currentCamera',1);
        this.playAnimationsWithCrossFade(this.animation.actions.carFailure, 'currentCarAnimation', 0.2);
        this.playAnimationsWithCrossFade(this.animation.raccoonFailure, 'currentRaccoonAnimation', 0.1);
        this.handleGameFinish();

        // gsap.fromTo(this.environment.headLight1, { intensity: 10 }, { intensity: 0, duration: 1.1, delay: 3 });
        // gsap.fromTo(this.environment.headLight2, { intensity: 10 }, { intensity: 0, duration: 1.1,  delay: 3 });
    }

    runSuccessScene() {
        this.playAnimationsWithCrossFade(this.animation.actions.CameraSuccess, 'currentCamera',1);
        this.playAnimationsWithCrossFade(this.animation.actions.carSuccess, 'currentCarAnimation', 0.2);
        this.playAnimationsWithCrossFade(this.animation.actions.RaccoonSuccess, 'currentRaccoonAnimation', 0.1);
        this.playAnimationArrayOnce(this.animation.raccoonExplosion);
    }

    handleGameFinish() {
        document.querySelector('.restart__game-over').innerHTML = 'Game Over';
        gsap.to('[data-restart]', { autoAlpha: 1, delay: 12 });

        this.isExperienceInProgress = false;
    }

    playAnimationsWithCrossFade(newAnimation, currentAnimation, time) {
        const oldAction = this.animation.actions[currentAnimation];

        this.animation.actions[currentAnimation] = newAnimation;
        this.animation.actions[currentAnimation].clampWhenFinished = true;
        this.animation.actions[currentAnimation].loop = THREE.LoopOnce;
        this.animation.actions[currentAnimation].reset();
        this.animation.actions[currentAnimation].play();
        this.animation.actions[currentAnimation].crossFadeFrom(oldAction, time);
    }

    playAnimationArrayOnce(animationArr) {
        animationArr.forEach(a => {
            a.clampWhenFinished = true;
            a.loop = THREE.LoopOnce;
            a.reset();
            a.play();
        });
    }

    update() {
        this.animation.mixer.update(this.time.delta / 1000);
        if(this.game) this.game.update();
    }
}